import { useAccount, useMsal } from '@azure/msal-react';
import { PropsWithChildren, useEffect } from 'react';

import { setADUser } from 'library/redux/application';
import { useAppDispatch } from 'library/redux/hooks';

export const MsalAccountSetting = ({
	children,
	onMsalChanged,
}: PropsWithChildren<{
	onMsalChanged: (isInitialized: boolean) => void;
}>) => {
	const dispatch = useAppDispatch();
	const { instance, accounts, inProgress } = useMsal();
	const account = useAccount(accounts[0] || {});

	useEffect(() => {
		if (account && inProgress === 'none') {
			instance.setActiveAccount(account);
			dispatch(setADUser(account));
			onMsalChanged(!!account);
		}
	}, [account, dispatch, instance, onMsalChanged, inProgress]);

	return children;
};
